export default "__VITE_ASSET__BTPC8JOB__"